import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";

import {
  LiveReportLink,
  UpdateLiveReportLinkInput,
} from "../../models/live-report";
import { managedLiveReportLinksQueryKey } from "./useManagedLiveReportLinks";
import { updateManagedLiveReportLink } from "../../client/manager/live-report";
import { useTixologiTokenRefresher } from "./useTixologiTokenRefresher";

interface UpdateLiveReportLinkVariables {
  id: number;
  patch: UpdateLiveReportLinkInput;
}

export function useUpdateManagedLiveReportLink(
  partnerId: string | undefined,
  isComedian = false
): UseMutationResult<LiveReportLink, Error, UpdateLiveReportLinkVariables> {
  const queryClient = useQueryClient();
  const { token, refresh } = useTixologiTokenRefresher(partnerId, isComedian);

  return useMutation({
    mutationFn: async ({ id, patch }: UpdateLiveReportLinkVariables) => {
      const initial = token ?? (await refresh());
      if (!initial) throw new Error("Tixologi token not available");
      return updateManagedLiveReportLink(initial, id, patch, refresh);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: managedLiveReportLinksQueryKey(partnerId),
      });
    },
  });
}
